module.exports = __webpack_public_path__ + "img/products.4bb8ff9e.png";